import { isRouteErrorResponse, Link, useRouteError } from 'react-router'

import { Icon } from '@/components/icons/Icon'
import b from '@/components/ui/buttons.module.css'
import { EmptyState } from '@/components/ui/EmptyState'
import { paths } from '@/lib/routes'

/**
 * Route-level error boundary: a failed lazy chunk (e.g. after a deploy, on patchy 4G) or a render
 * error never blanks the app.
 */
export default function ErrorPage() {
  const error = useRouteError()
  const notFound = isRouteErrorResponse(error) && error.status === 404
  return (
    <div className="wrap">
      <EmptyState
        icon={<Icon name={notFound ? 'search' : 'info'} size={36} />}
        title={notFound ? 'Page not found' : 'Something went wrong'}
        text={notFound ? undefined : 'Check your connection, then reload the page.'}
        headingLevel={1}
      >
        {!notFound && (
          <button
            type="button"
            className={`${b.btn} ${b.primary} ${b.lg}`}
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
        )}
        <Link to={paths.home()} className={`${b.btn} ${b.ghost} ${b.lg}`}>
          Go to Home
        </Link>
      </EmptyState>
    </div>
  )
}
